<template>
    <div class="dialog" id="add-product-to-proposal-modal" aria-hidden="true">
        <div class="dialog-overlay" tabindex="-1" data-a11y-dialog-hide></div>
        <div
            role="dialog"
            class="dialog-content"
            aria-labelledby="my-dialog-title"
            aria-describedby="my-dialog-description"
        >
            <button
                data-a11y-dialog-hide
                class="dialog-close"
                aria-label="Close this dialog window"
            >
                <img src="@/assets/images/dialog-close.svg" width="24" height="24" alt="Dialog close" />
            </button>

            <div class="exchange-dialog loader-block-parent">
                <div v-show="isLoading" class="loader-block">
                    <div>
                        <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
                    </div>
                </div>
                <p class="exchange-dialog__name">Dodaj nowy produkt</p>
                <div class="exchange-dialog__top">
                    <p>{{proposal?.styles}}</p>
                    <div>
                        <button>
                            <img src="@/assets/icons/sorts.svg" width="24" height="24" :alt="$t('projects.list.sort')" />Sortuj
                            <div class="list">
                                <div class="list__inner">
                                    <ul>
                                        <li v-for="(sortType,index) in sortTypes" :key="index">
                                            <div class="control control--check">
                                                <input name="sort" type="radio" :id="sortType.toLowerCase()" @click="sortProducts(sortType)" />
                                                <label :for="sortType.toLowerCase()" class="control__label">
                                                    {{ $t('admin.all_products.sort_list.' + sortType) }}
                                                </label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </button>
                        <button style="display: none" id="openFilters" @click="showFilters = true" ref="clickOutside">
                            <img src="@/assets/icons/filter.svg" alt="" />Filtruj
                        </button>
                    </div>
                </div>
                <div class="exchange-dialog__filters" v-show="showFilters">
                    <p class="exchange-dialog__filters__name">Filtrowanie</p>
                    <ul class="exchange-dialog__filters-main">
                        <li data-id="fabric" v-for="(filterType,index) in filterTypes">
                            {{filterType.name_pl}}
                            <img :src="filterType.imagePath" :alt="filterType.name_pl" />
                        </li>
                    </ul>
                    <div class="exchange-dialog__back">
                        <img src="https://via.placeholder.com/16" alt="" />
                    </div>
                    <ul class="exchange-dialog__options" id="fabric">
                        <li>
                            <div class="control control--check">
                                <input type="checkbox" id="qwe" />
                                <label for="qwe" class="control__label">skórka</label>
                                <span>12</span>
                            </div>
                        </li>
                    </ul>
                    <ul class="exchange-dialog__options" id="lorem">
                        <li>
                            <div class="control control--check">
                                <input type="checkbox" id="leather" />
                                <label for="leather" class="control__label">Skóra</label>
                            </div>
                        </li>
                        <li>
                            <div class="control control--check">
                                <input type="checkbox" id="leather2" />
                                <label for="leather2" class="control__label"
                                >Eco skóra</label
                                >
                            </div>
                        </li>
                    </ul>
                    <div class="exchange-dialog__filters__buttons">
                        <button>Wyczyść</button>
                        <button
                            id="hideFilters"
                            class="exchange-dialog__button-ready"
                        >
                            Gotowe
                        </button>
                    </div>
                </div>
                <div class="exchange-dialog__items">
                    <div class="exchange-dialog__product"
                         v-for="(product,index) in otherProposalProducts"
                         :key="index"
                         @click="selectItem(index,product)"
                         :class="{'active': index == selectedItem}"
                    >
                        <div
                            class="exchange-dialog__product-image"
                            :style="{backgroundImage: 'url(' + product?.imagePath + ')'}"
                        ></div>
                        <p class="exchange-dialog__product-name">{{product?.name}}</p>
                        <p class="exchange-dialog__product-price">Cena: {{product?.price}} PLN</p>
                    </div>
                </div>
                <button @click="addProduct" class="exchange-dialog__select">Wybierz</button>
            </div>
        </div>
    </div>

</template>

<script>
import {ref, onMounted, inject} from "vue";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import authHelper from "@/helpsers/auth.helper";
import AlertHelper from "@/helpsers/alert.helper";
import {useI18n} from "vue-i18n";
import {useClickOutside} from "@/helpsers/click-outside.helpers";

export default {
    name: "addProductToProposalModel",
    setup(props,{emit}) {
        const addProductModal = ref(),
            architectProposalProduct = ref(),
            otherProposalProducts = ref(),
            isLoading = ref(false),
            proposal = ref(),
            selectedItem = ref(),
            {t} = useI18n(),
            sortTypes = ref(),
            showFilters = ref(false),
            clickOutside = ref(''),
            filterTypes = ref('');


        let selectedProduct = ref(),
            alert = inject('alert'),
            order = null;


        onMounted(() => {
            addProductModal.value = new A11yDialog(document.querySelector("#add-product-to-proposal-modal"));
        })

        useClickOutside(clickOutside,(e) => {
            showFilters.value = false;
        });

        function showModal(proposalInfo) {
            proposal.value = proposalInfo;
            getAllProposalProducts();
            addProductModal.value.show();
        }

        function getAllProposalProducts() {
            isLoading.value = true;
            const requestParams = {
                onPage: 100000,
                designProposalId: proposal.value.id,
            };
            if(order)
                requestParams.order = order;

            axios.get(ApiHelper.getAllProductsUrl(), {
                headers: authHelper.authHeader(),
                params: requestParams

            }).then(result => {
                otherProposalProducts.value = result.data.data;
                isLoading.value = false;
            }).catch(errorResponse => {
                console.log(errorResponse);
                isLoading.value = false;
            });
        }

        function selectItem(index,product) {
            selectedItem.value = index;
            selectedProduct.value = product
        }

        function addProduct() {
            isLoading.value = true;

            axios.post(ApiHelper.getAddProductToProposalUrl(proposal.value.id), {
                productId: selectedProduct.value.id
            }, {
                headers: authHelper.authHeader()
            }).then(response => {
                isLoading.value = false;
                AlertHelper.show(alert, t('project_details.proposal.success_add_product'));
                addProductModal.value.hide();
                emit('refresh-proposal',response.data);
                selectedItem.value = null;

            }).catch(errorResponse => {
                isLoading.value = true;
                let errorMessage = ApiHelper.getResponseMessage(errorResponse.response?.data?.code);
                AlertHelper.show(alert, errorMessage, '', 'error');
                addProductModal.value.hide();
                selectedItem.value = null;
            })
        }

        function fetchSortTypes() {
            axios.get(ApiHelper.getAllProductsSortTypesUrl(), {
                headers: authHelper.authHeader(),
            }).then(result => {
                sortTypes.value = result.data ?? [];
            }).catch(errorResponse => {

            })
        }
        fetchSortTypes();

        function fetchFilterTypes() {
            axios.get(ApiHelper.getProductTypesUrl(), {
                headers: authHelper.authHeader(),
            }).then(result => {
                filterTypes.value = result.data ?? [];
            }).catch(errorResponse => {

            })
        }
        fetchFilterTypes();

        function sortProducts(sortType) {
            order = sortType;
            getAllProposalProducts();
        }

        return {
            showModal,
            architectProposalProduct,
            otherProposalProducts,
            isLoading,
            proposal,
            selectedItem,
            selectItem,
            addProduct,
            sortTypes,
            sortProducts,
            showFilters,
            clickOutside,
            filterTypes
        }
    }
}
</script>

<style scoped lang="scss">
@use "@/css/proposals";

.exchange-dialog {
    .control {
        &--check {
            label {
                text-align: left;
                cursor: pointer;
            }
        }
    }


    &__items {
        justify-content: space-around;
    }

    &__product {

        &.active {
            border: 2px solid #9e5d57;
        }
    }

    &__filters {
        display: block;
    }
}
</style>